import React from 'react';
import LiveMap from './components/LiveMap';

function App() {
  return <LiveMap />;
}

export default App;
